import React from 'react';

import BaseComponent from 'src/components/BaseComponent';
import ShortInfo from 'src/components/user/ShortInfo';
import { MCButton } from 'src/components/basic';
import PopupSelect from 'src/components/complex/popupSelect';
import { lang, remCss } from 'src/helpers';
import constants from 'src/constants';

import { STEPS } from './constants';
import LANG_CONST from 'src/helpers/lang/const';

export class Doctor extends BaseComponent {
  get model() {
    return this.props.model;
  }

  get config() {
    return this.props.config;
  }

  componentDidMount() {
    this.model.subscribe(this.subscription);
  }

  componentWillUnmount() {
    this.model.unsubscribe(this.subscription);
  }

  next = (e) => {
    e.preventDefault();
    if (!this.model.state.doctorId) {
      this.model.setInvalidApi(this.model.state.saveApi, {
        length: 1,
        doctor: lang.t(LANG_CONST.validation.required, { label: lang.t(LANG_CONST.doctor) })
      });
    } else {
      this.model.setState({ step: STEPS.PATIENT });
    }
  };

  render = () => {
    const { invalid, loading } = this.model.getApiState(this.model.state.saveApi);
    const active = this.model.state.step === STEPS.DOCTOR;
    return (
      <div className={'mc-tab-content ' + (active ? '' : 'mc-inactive')}>
        <div style={{ maxWidth: remCss(500), flex: 1 }}>
          {active && (
            <PopupSelect
              template={5}
              isPopover={true}
              isClearable={false}
              label={LANG_CONST.select_a_doctor}
              placeholder={LANG_CONST.select}
              name={'doctor'}
              invalid={invalid}
              value={this.model.state.doctorId}
              initSelectedParamKey={'doctorId'}
              apiConfig={{
                ...this.config.doctorList,
                labelFn: (user) => <ShortInfo small user={user} specialist={[]} />,
                disabledFn: (user) => user.status === constants.general.userStatus.disabled
              }}
              selectedLabelFn={(user) => <ShortInfo small user={user} specialist={[]} />}
              onChange={(n, v, a) => {
                this.model.resetApiState(this.model.state.saveApi);
                this.model.setState({ doctorId: a.item.id, doctor: a.item });
              }}
            />
          )}
        </div>
        <div className={'mc-flex-20'}>
          <div className={'mc-grow'} />
          <MCButton
            primary
            medium
            radius
            light
            style={{ width: remCss(100) }}
            label={LANG_CONST.buttons.cancel}
            disabled={loading}
            onClick={this.props.onBack}
          />
          <MCButton
            primary
            medium
            radius
            dark
            label={LANG_CONST.buttons.next}
            style={{ width: remCss(100) }}
            disabled={loading}
            loading={loading}
            onClick={this.next}
          />
        </div>
      </div>
    );
  };
}
